var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('RenewalsFilter',{attrs:{"prefill":_vm.prefillFilters},on:{"search":_vm.applyFilter,"export":_vm.handleExport,"clear":_vm.clearList}}),_c('ListRenewals',{attrs:{"filter":_vm.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }